import { css, DefaultTheme } from 'styled-components';

const textQuote = (props: { theme: DefaultTheme }) =>
  // ts-ignore
  props.theme.colors.textQuote();

export const FaqMinusIconMixin = css`
  background: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Crect width='19' height='19' x='.5' y='.5' fill='%23FFF' stroke='${textQuote}' stroke-opacity='.1' rx='9.5' /%3E%3Crect width='8' height='2' x='6' y='9' fill='${textQuote}' fill-rule='nonzero' rx='1' /%3E%3C/g%3E%3C/svg%3E");
`;

export const FaqPlusIconMixin = css`
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Crect width='19' height='19' x='.5' y='.5' fill='%23FFF' stroke='${textQuote}' stroke-opacity='.1' rx='9.5'/%3E%3Cpath fill='${textQuote}' fill-rule='nonzero' d='M9 9V7a1 1 0 1 1 2 0v2h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0v-2H7a1 1 0 0 1 0-2h2z'/%3E%3C/g%3E%3C/svg%3E%0A");
`;
